import styled from 'styled-components';

const Form = styled.form`
  width: 100%;
  max-width: 810px;
  color: #505050;
`;

export default Form;
